"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostileTo = isHostileTo;
exports.isFriendlyTo = isFriendlyTo;
exports.isNeutralTo = isNeutralTo;
function isHostileTo(char, faction) {
    if (!char.allegianceReputation?.[faction])
        return false;
    const rep = char.allegianceReputation[faction] ?? 0;
    return rep <= -100;
}
function isFriendlyTo(char, faction) {
    if (!char.allegianceReputation?.[faction])
        return false;
    const rep = char.allegianceReputation[faction] ?? 0;
    return rep >= 100;
}
function isNeutralTo(char, faction) {
    if (!char.allegianceReputation?.[faction])
        return true;
    return !isHostileTo(char, faction) && !isFriendlyTo(char, faction);
}
